import { FormControl } from '@angular/forms';
import { EstateData } from 'src/lib/fliko/models/estate/estate.data';

export interface ContextData {
  type: ContextType;
  estates: EstateData[];
  companyIds: string[];
  // ? flag that checks if user/employee has 'c_' permissions
  hasCompanyAccess: boolean;
}

export enum ContextType {
  ESTATE = 'estate',
  COMPANY = 'company'
}

export interface FestiveTheme {
  /** Firebase url */
  image: string;
  text: string;
  /** HEX value */
  textColor: string;
  /** img for image, txt for text, semicolon as separator, eg. img;txt;img */
  pattern: string;
}

export interface SwitchContextData {
  estateControl: FormControl;
  contextType: ContextType;
  contextData: ContextData;
  estates: EstateData[];
}
